import { Component, Vue } from 'vue-property-decorator';
import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import OmniSearch from '../omni-search/index.vue';

@Component({
    components: {
        'app-omnisearch': OmniSearch,
    },
})
export default class HeaderComponent extends Vue
{
    private quickAdd = false;

    /**
     * Returns the logo path for the header
     */

    private get logo(): string
    {
        return require('@/assets/images/logos/vp-logo-full_white.svg');
    }

    /**
     * Returns the logo path for the Google login button
     */

    private get googleLogo(): string
    {
        return require('@/assets/images/vendor/google/logo.svg');
    }

    /**
     * Returns the Google sign in config
     */

    private get googleSignInConfig()
    {
        return {
            apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
            clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
            discoveryDocs: process.env.VUE_APP_GOOGLE_API_DISCOVERY_DOCS.split(','),
            scope: process.env.VUE_APP_GOOGLE_API_SCOPE,
        };
    }

    /**
     * Returns the page title for the header
     */

    private get pageTitle(): string
    {
        return this.$vuetify.breakpoint.mdAndUp ? this.$t('general.message.app_title').toString() : '';
    }

    /**
     * Toggles visibility of the navbar
     */

    private onToggleNavbar()
    {
        this.$store.commit('ui/navbarVisible', !this.$store.getters['ui/navbarVisible']);
    }

    /**
     * Handles failed logins
     */

    private onLoginFailed()
    {
        // Redirect to the forgotten password page
        this.$router.push({ name: 'forgotten-password' }).catch();
    }

    /**
     * Handles log outs
     */

    private onLoggedOut()
    {
        // Redirect to the home page
        this.$router.push({ name: 'home' }).catch();
    }

    /**
     * Handles create meeting requests
     */

    private onCreateMeeting()
    {
        EventBus.instance.$emit('create-meeting');
    }
}